/** Navigation state sent to the login screen by a protected page (VOL-326). */
export interface LoginRedirectState {
  from: string;
}

/** Path, query and hash of the page to reopen after login. */
export function loginRedirectState(location: { pathname: string; search: string; hash: string }): LoginRedirectState {
  return { from: `${location.pathname}${location.search}${location.hash}` };
}

/**
 * Page to reopen after login, or null. Only same-origin app paths: `//host`
 * or `/\host` would make `navigate` leave the site.
 */
export function loginReturnPath(state: unknown): string | null {
  if (typeof state !== 'object' || state === null || !('from' in state)) return null;
  const { from } = state;
  if (typeof from !== 'string' || !from.startsWith('/') || from.startsWith('//') || from.startsWith('/\\')) {
    return null;
  }
  // Coming back to the login page itself would loop.
  return from === '/' || from.startsWith('/login') ? null : from;
}
